// store configuration
import configureStore from './configureStore';
// socket client
import SocketClient from '../services/SocketClient';

const socketClient = new SocketClient();

export const store = configureStore(socketClient);
